const page = require("../../../../../components/page/page");
const accountsReceivableDt = require("./accountsReceivable-dt");

import accountsReceivablePage from "./accountsReceivable-page.html";

/****************ELEMENTS*****************/
var HTMLwasSelected = false;

//insert the page  on the body
function HTMLselect(detail) {
  //console.log('accountsReceivable init>')

  HTMLwasSelected = true;

  //load the page to the index
  const body = document.body;
  body.insertAdjacentHTML("beforeend", accountsReceivablePage);

  accountsReceivableDt.start({
    dest: "accountsReceivable",
    act: "fecthData",
  });
} /*init*/

/****************ELEMENTS*****************/

export function start(detail) {
  //console.log('accountsReceivable page >', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
}

const obj = {
  show: {
    start: (detail) => {
      page.start(detail);
    },
  },
}; /**/
